import React, { useEffect, useMemo, useState } from 'react';
import { Calendar, Clock, Plus, Trash2 } from 'lucide-react';
import HourglassLoader from './ui/HourglassLoader';
import apiClient from '../lib/apiClient';
import './Scheduling.css';

function Scheduling() {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ content: '', platform: 'instagram', scheduled_at: '' });

  const loadSchedules = async () => {
    setLoading(true);
    try {
      const data = await apiClient.request('/schedules');
      if (data?.success) setSchedules(data.schedules || []);
    } catch (error) {
      console.error('Erro ao carregar agendamentos:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSchedules();
  }, []);

  const createSchedule = async () => {
    if (!form.content || !form.scheduled_at) {
      alert('Preencha conteúdo e data/hora.');
      return;
    }

    try {
      const data = await apiClient.request('/schedules', {
        method: 'POST',
        body: JSON.stringify(form)
      });
      if (data?.success) {
        setSchedules((prev) => [...prev, data.schedule]);
        setForm({ content: '', platform: 'instagram', scheduled_at: '' });
        setShowForm(false);
      }
    } catch (error) {
      console.error('Erro ao criar agendamento:', error);
    }
  };

  const deleteSchedule = async (id) => {
    if (!window.confirm('Cancelar este agendamento?')) return;
    try {
      const data = await apiClient.request(`/schedules/${id}`, { method: 'DELETE' });
      if (data?.success) {
        setSchedules((prev) => prev.filter((item) => item.id !== id));
      }
    } catch (error) {
      console.error('Erro ao excluir agendamento:', error);
    }
  };

  const ordered = useMemo(() => {
    return [...schedules].sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at));
  }, [schedules]);

  return (
    <div className="scheduling-page">
      <div className="scheduling-header">
        <button className="btn btn-outline" onClick={() => setShowForm((prev) => !prev)}>
          <div className="blob1"></div>
          <div className="blob2"></div>
          <div className="inner">
            <Plus size={16} /> Novo agendamento
          </div>
        </button>
      </div>

      {showForm && (
        <section className="schedule-modal card">
          <div className="modal-body">
            <div className="input-group">
              <label>Conteúdo</label>
              <textarea
                rows={4}
                value={form.content}
                onChange={(event) => setForm((prev) => ({ ...prev, content: event.target.value }))}
              />
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>Plataforma</label>
                <select
                  value={form.platform}
                  onChange={(event) => setForm((prev) => ({ ...prev, platform: event.target.value }))}
                >
                  <option value="instagram">Instagram</option>
                  <option value="facebook">Facebook</option>
                  <option value="linkedin">LinkedIn</option>
                  <option value="twitter">Twitter/X</option>
                </select>
              </div>
              <div className="input-group">
                <label>Data e Hora</label>
                <input
                  type="datetime-local"
                  value={form.scheduled_at}
                  onChange={(event) => setForm((prev) => ({ ...prev, scheduled_at: event.target.value }))}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline" onClick={createSchedule}>Salvar</button>
              <button className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancelar</button>
            </div>
          </div>
        </section>
      )}

      {loading && <HourglassLoader variant="inline" message="Carregando agendamentos..." />}

      {!loading && (
        <section className="upcoming-section">
          <h3>Próximos agendamentos</h3>
          <div className="upcoming-posts">
            {ordered.map((item) => (
              <article key={item.id} className="upcoming-post card">
                <div className="post-details">
                  <h4>{item.content}</h4>
                  <div className="post-meta">
                    <span><Calendar size={14} /> {new Date(item.scheduled_at).toLocaleDateString('pt-BR')}</span>
                    <span><Clock size={14} /> {new Date(item.scheduled_at).toLocaleTimeString('pt-BR')}</span>
                    <span>{item.platform}</span>
                  </div>
                </div>
                <div className="post-actions">
                  <button className="btn btn-secondary" onClick={() => deleteSchedule(item.id)}>
                    <Trash2 size={14} /> Excluir
                  </button>
                </div>
              </article>
            ))}

            {!ordered.length && (
              <div className="card empty-state">
                <h3>Nenhum agendamento</h3>
                <p>Crie seu primeiro agendamento para organizar publicações.</p>
              </div>
            )}
          </div>
        </section>
      )}
    </div>
  );
}

export default Scheduling;
